__turbopack_context__.v({
  "calculatedAmount": "AgreementSingleCauseAreaDetails-module-scss-module__dtLbWW__calculatedAmount",
  "values": "AgreementSingleCauseAreaDetails-module-scss-module__dtLbWW__values",
  "valuesAmountContainer": "AgreementSingleCauseAreaDetails-module-scss-module__dtLbWW__valuesAmountContainer",
  "valuesDatePickerContainer": "AgreementSingleCauseAreaDetails-module-scss-module__dtLbWW__valuesDatePickerContainer",
  "valuesSmartDistributionToggle": "AgreementSingleCauseAreaDetails-module-scss-module__dtLbWW__valuesSmartDistributionToggle",
  "valuesTaxUnitSelectorContainer": "AgreementSingleCauseAreaDetails-module-scss-module__dtLbWW__valuesTaxUnitSelectorContainer",
});
